import { Star, Quote } from "lucide-react";
import { TESTIMONIALS, COMPANY } from "@/data/site";

export default function Testimonials() {
  return (
    <section id="reviews" className="bg-white border-y border-slate-200">
      <div className="max-w-7xl mx-auto px-6 md:px-12 lg:px-24 py-20 md:py-28">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-6 mb-12">
          <div>
            <div className="flex items-baseline gap-3">
              <span className="font-display font-black text-sm text-[#A88852]">03 —</span>
              <div className="label-eyebrow">Reviews</div>
            </div>
            <h2 className="font-display text-4xl md:text-5xl font-black tracking-tight mt-2 text-slate-900 max-w-2xl">
              {COMPANY.reviewCount}+ five-star reviews from your neighbors.
            </h2>
          </div>
          <div className="flex items-center gap-2 bg-slate-50 border border-slate-200 px-4 py-2.5 rounded-md">
            <div className="flex">
              {Array.from({ length: 5 }).map((_, i) => (
                <Star key={i} size={16} className="fill-orange-500 text-orange-500" />
              ))}
            </div>
            <span className="font-display font-bold text-slate-900">{COMPANY.rating}</span>
            <span className="text-sm text-slate-500">/ 5 avg. rating</span>
          </div>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-5">
          {TESTIMONIALS.map((t, i) => (
            <figure
              key={i}
              data-testid={`testimonial-${i}`}
              className="bg-slate-50 border border-slate-200 rounded-md p-6 flex flex-col"
            >
              <Quote size={22} className="text-orange-500" />
              <blockquote className="text-slate-700 text-sm leading-relaxed mt-3 flex-1">
                "{t.quote}"
              </blockquote>
              <div className="flex items-center gap-1 mt-4">
                {Array.from({ length: t.rating }).map((_, j) => (
                  <Star key={j} size={13} className="fill-orange-500 text-orange-500" />
                ))}
              </div>
              <figcaption className="mt-2">
                <div className="font-display font-bold text-slate-900 text-sm">{t.name}</div>
                <div className="text-xs text-slate-500">{t.city}</div>
              </figcaption>
            </figure>
          ))}
        </div>
      </div>
    </section>
  );
}
